<div class="dialog-header">
  <h6>Port Agent Details</h6>
  <mat-icon color="warn" (click)="closeDialog()">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="field"><span class="field-label1" style="color: rgb(255, 255, 255);">Port Agent Company Name</span>
    <span>{{data.company_name}}</span>
  </div>
  <span class="field-label1">Email</span>
  <mat-chip-set class="email-chip">
    <mat-chip *ngFor="let mail of data.email" color="primary" selected>
      {{ mail }}
    </mat-chip>
  </mat-chip-set>
  <div class="address-field"><span class="field-label1" style="color: rgb(255, 255, 255);">Billing Address</span>
    <div class="address">{{data.address}}</div>
  </div>
  <br>
  <!-- BankDetails and billing Address -->
  <span class="field-label1">Enter Bank Details & Billing Address</span>
  <hr>
  <div>
    <div class="field"><span class="field-label">Beneficiary account Holder Name</span>
      <span>{{data.bank_details?.beneficiary_acc_holder_name}}</span>
    </div>
    <div class="field"><span class="field-label">Bank Name</span>
      <span>{{data.bank_details?.bank_name}}</span>
    </div>
    <div class="field"><span class="field-label">Account Number</span>
      <span>{{data.bank_details?.current_account_number}}</span>
    </div>
    <div class="field"><span class="field-label">Correspondent Account Number</span>
      <span>{{data.bank_details?.correspondent_account_number}}</span>
    </div>
    <div class="field"><span class="field-label">IBAN Number</span>
      <span>{{data.bank_details?.iban_number}}</span>
    </div>
    <div class="field"><span class="field-label">SWIFT Code</span>
      <span>{{data.bank_details?.swift_code}}</span>
    </div>
    <div class="field"><span class="field-label"> BIC Code</span>
      <span>{{data.bank_details?.bic_code}}</span>
    </div>
    <div class="field"><span class="field-label">INN Code</span>
      <span>{{data.bank_details?.inn_code}}</span>
    </div>
    <div class="field"><span class="field-label">BIK Code </span>
      <span>{{data.bank_details?.bik_code}}</span>
    </div>
    <div class="field"><span class="field-label">IFSC Code</span>
      <span>{{data.bank_details?.ifsc_code}}</span>
    </div>
    <div class="field"><span class="field-label">Country</span>
      <span>{{data.bank_details?.country_name}}</span>
    </div>
    <div class="field"><span class="field-label">Currency</span>
      <span>{{data.bank_details?.currency}}</span>
    </div>
    <div class="address-field"><span class="field-label">Bank Branch with Address</span>
      <div class="address">{{data.bank_details?.branch_address}}</div>
    </div>
  </div>


</mat-dialog-content>